import { Link } from "@tanstack/react-router";
import ArrowForward from "~icons/material-symbols/arrow-forward";
import Info from "~icons/material-symbols/info-outline";
import { css } from "../../../../styled-system/css";
import { t } from "../../../libs/i18n";

export const KyotoRepresentativeCampaignBanner = () => {
  return (
    <section
      className={css({
        bg: "surface.accentPrimaryLight",
        border: "1px solid",
        borderColor: "border.secondary",
        rounded: "xl",
        p: "16px",
        display: "flex",
        flexDir: "column",
        gap: "16px",
      })}
    >
      <div
        className={css({
          display: "flex",
          alignItems: "flex-start",
          gap: "4px",
        })}
      >
        <Info
          className={css({
            color: "text.accentPrimary",
            flexShrink: 0,
            width: "24px",
            height: "24px",
          })}
        />
        <p
          className={css({
            fontSize: "16px",
            lineHeight: 1.5,
          })}
        >
          {t("京都ポイントを受け取りましょう！")}
        </p>
      </div>

      <p
        className={css({
          color: "text.secondary",
          fontSize: "14px",
          lineHeight: 1.4,
        })}
      >
        {t(
          "ご家族等のマイナンバーカードの読み取りで、ご家族等分のポイントも受け取ることができます。",
        )}
      </p>

      <Link
        to="/kyoto-representative-campaign"
        className={css({
          bg: "surface.accentPrimary",
          color: "text.inverse",
          rounded: "xl",
          px: "24px",
          py: "12px",
          minH: "48px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "4px",
          fontSize: "16px",
          fontWeight: 600,
          textDecoration: "none",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.03)",
        })}
      >
        {t("ポイントの受け取りへ")}
        <ArrowForward
          className={css({
            width: "24px",
            height: "24px",
          })}
        />
      </Link>

      <a
        href="https://kyopo.city.kyoto.lg.jp/"
        target="_blank"
        rel="noreferrer"
        className={css({
          color: "text.accentPrimary",
          fontSize: "14px",
          lineHeight: 1.4,
          textAlign: "center",
          textDecoration: "underline",
        })}
      >
        {t("キャンペーン詳細")}
      </a>
    </section>
  );
};
